// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldItem_root__2PN84","editable":"FieldItem_editable__3NbuH"};